import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import InscriptionFormsListView from "./inscriptions_forms-list.html";
import InscriptionFormsEditView from "./inscriptions_forms-edit.html";

angular.module("inscriptions_forms", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('inscriptions_forms', {
                url: "/inscriptionsForms",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
                cache: false,
            })
            .state('inscriptions_forms.list', {
                url: "/list",
                controller: "InscriptionsFormsListCtrl",
                template: InscriptionFormsListView,
                data: { pageTitle: 'Inscriptions Forms' },
                cache: false,
                requiredPermission: ["INSCRIPTIONS_FORMS_READ"],
                resolve: {
                    event: function () { return null },
                    is_template: function () {return true }
                }

            })
            .state('inscriptions_forms.edit', {
                url: "/edit/:inscription_form_id",
                controller: "InscriptionsFormsEditCtrl",
                template: InscriptionFormsEditView,
                data: { pageTitle: 'Inscriptions Forms' },
                cache: false,
                requiredPermission: ["INSCRIPTIONS_FORMS_WRITE"],
                resolve: {
                    event: function () { return null },
                    is_template: function () { return true }
                }
            })

            ;

    }])
;